// extracted by mini-css-extract-plugin
module.exports = {"container":"_1QhHzLxQRcCcOnqANSCj77","spam":"n4EnpKmlKEjeloU39TMto","buttons":"_2uFWxjz39akYZc54ejhFzn","additional":"wIAN-l90KWDedIukCnNsK"};